import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 商品名を取得するユースケース
 * @param business - 取引情報
 */
export class GetBusinessNameUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * 取引先名を取得する
   * @param businessNumber - 商品番号
   */
  async execute(businessNumber: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = this.repository.getBusinessName(businessNumber);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
